import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "note-suggested-action-wrap" }
const _hoisted_2 = { class: "note-suggested-action-header" }
const _hoisted_3 = { class: "suggested-action-header-breadcrumb" }
const _hoisted_4 = { class: "shrink-0" }
const _hoisted_5 = { class: "note-suggested-action" }
const _hoisted_6 = { class: "note-suggested-action-footer" }

import { computed } from 'vue';
import CompactCard from '@/components/widgets/CompactCard';
import NoteSuggestedActionDetails from '@/components/notes/NoteSuggestedActionDetails';
import useSuggestions from '@/utilities/composables/useSuggestions';
import useTranslate from '@/utilities/composables/useTranslate';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import ButtonCustom from '@/components/elements/ButtonCustom';
import useSuggestedActions from '@/utilities/composables/useSuggestedActions';


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteSuggestedAction',
  props: {
  action: {
    type: Object,
    required: true,
  },
},
  emits: ['accept', 'reject'],
  setup(__props, { emit: __emit }) {

const { suggestionTooltip } = useSuggestions();
const { translate } = useTranslate();
const { actionTypeDefinitions, actionTypes } = useSuggestedActions();

const props = __props;

const emit = __emit;

const DEFAULT_TOOLTIP_OPTIONS = {
  placement: 'top',
  offset: [0, 4],
};

const actionType = computed(() => {
  return props.action.type || Object.keys(actionTypes).find((key) => props.action[key]) || '';
});

const actionDetails = computed(() => {
  return props.action[actionType.value] || {};
});

const actionResourceTitle = computed(() => {
  return actionDetails.value.title || '';
});

const isCreateCardAction = computed(() => {
  return actionType.value === actionTypes.create_card;
});

const actionTypeProperties = computed(() => {
  return actionTypeDefinitions[actionType.value] || {};
});

const actionName = computed(() => {
  const action = actionTypeProperties.value.headerTitleKey || '';
  return action ? `${translate(action)}` : '';
});

const actionCardId = computed(() => {
  return actionDetails.value.card_id || '';
});

// Filter out empty or null values and also filter out card_id
const validActionDetails = computed(() => {
  const details = actionDetails.value;
  if (!details || typeof details !== 'object') return {};

  return pickBy(details, (value, key) => {
    return !isEmpty(value) && key !== 'card_id';
  });
});

const acceptButtonText = computed(() => {
  return translate(actionTypeProperties.value.acceptButtonKey ?? 'accept');
});

const acceptButtonIconName = computed(() => {
  return actionTypeProperties.value.acceptButtonIcon ?? 'check';
});

const rejectButtonTooltip = computed(() => {
  return { ...suggestionTooltip('reject'), ...DEFAULT_TOOLTIP_OPTIONS };
});

const acceptButtonTooltip = computed(() => {
  return { ...suggestionTooltip('accept'), ...DEFAULT_TOOLTIP_OPTIONS };
});

const accept = (event: any) => {
  const dataForEmit = {
    ...props.action,
    [actionType.value]: pickBy(actionDetails.value, (value) => !isEmpty(value)),
  };
  emit('accept', dataForEmit, event);
};

const reject = (event: any) => {
  emit('reject', props.action, event);
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(actionName.value), 1),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (!isCreateCardAction.value)
          ? (_openBlock(), _createBlock(_unref(CompactCard), {
              key: 0,
              "card-id": actionCardId.value,
              title: actionResourceTitle.value
            }, null, 8, ["card-id", "title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(NoteSuggestedActionDetails), {
        "action-details": validActionDetails.value,
        "card-id": actionCardId.value,
        "action-type": actionType.value
      }, null, 8, ["action-details", "card-id", "action-type"])
    ]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createVNode(_unref(ButtonCustom), {
        type: 'suggestion-decline hover:bg-hover-onHover py-1 px-2',
        "button-dimensions": { height: 24 },
        "custom-icon-name": 'x',
        "custom-icon-size": '16px',
        "custom-icon-color": 'var(--destructiveIcon)',
        text: _unref(translate)('reject'),
        onClick: reject
      }, null, 8, ["text"]), [
        [_directive_tooltip, rejectButtonTooltip.value]
      ]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _withDirectives(_createVNode(_unref(ButtonCustom), {
        type: 'suggestion-accept hover:bg-hover-onHover py-1 px-2',
        "button-dimensions": { height: 24 },
        "custom-icon-name": acceptButtonIconName.value,
        "custom-icon-size": '16px',
        "custom-icon-color": 'var(--positiveIcon)',
        text: acceptButtonText.value,
        onClick: accept
      }, null, 8, ["custom-icon-name", "text"]), [
        [_directive_tooltip, acceptButtonTooltip.value]
      ])
    ])
  ]))
}
}

})